import React from "react";
import { Input } from "../Input";
import { TextArea } from "../TextArea";

interface Step2Props {
  handleChange: any;
  errors: any;
  values: any;
  handleChangeCEP: (cep: string) => Promise<void>;
}

export function Step2({
  errors,
  handleChange,
  values,
  handleChangeCEP,
}: Step2Props) {
  return (
    <div>
      <div className="flex">
        <div className="col">
          <Input
            label="CEP"
            inputMode="numeric"
            name="cep"
            maxLength={9}
            onChange={handleChange}
            onBlur={(e) => handleChangeCEP(e.currentTarget.value)}
            mask="99999-999"
            error={errors.cep}
            value={values.cep}
          />
        </div>

        <div className="col">
          <Input
            label="Rua"
            name="street"
            maxLength={14}
            onChange={handleChange}
            error={errors.street}
            value={values.street}
            // disabled
          />
        </div>
      </div>

      <div className="flex mb-3">
        <div className="col">
          <Input
            label="Bairro"
            name="neighborhood"
            maxLength={9}
            onChange={handleChange}
            error={errors.neighborhood}
            value={values.neighborhood}
            // disabled
          />
        </div>

        <div className="col">
          <Input
            label="Número"
            name="number"
            maxLength={14}
            onChange={handleChange}
            error={errors.number}
            value={values.number}
            inputMode="numeric"
          />
        </div>
      </div>

      <div className="flex mb-3">
        <div className="col">
          <Input
            label="Cidade"
            name="city"
            onChange={handleChange}
            error={errors.city}
            value={values.city}
            // disabled
          />
        </div>
        <div className="col">
          <Input
            label="Estado"
            name="state"
            onChange={handleChange}
            error={errors.state}
            value={values.state}
            maxLength={2}
            // disabled
          />
        </div>
      </div>

      <TextArea
        label="Complemento"
        name="addressComplement"
        onChange={handleChange}
        error={errors.addressComplement}
        value={values.addressComplement}
      />
    </div>
  );
}
